import { memo, HTMLProps, NamedExoticComponent, ReactNode } from 'react';

import styles from './styles.module.css';

type HeaderButtonProps = {
  onClick?: () => void;
  collapsed?: boolean;
  title: ReactNode;
  icon: ReactNode;
  linkProps?: HTMLProps<HTMLAnchorElement>;
};

const HeaderButton: NamedExoticComponent<HeaderButtonProps> = memo(
  ({ onClick, title, icon, linkProps }) => {
    const Tag = linkProps ? 'a' : 'button';
    const props = linkProps || { type: 'button', onClick };

    return (
      <Tag {...(props as any)} className={styles.headerButton}>
        {icon}
        <span className={styles.headerButtonTitle}>{title}</span>
      </Tag>
    );
  },
);

export default HeaderButton;
